import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SacredCrown from "@/pages/SacredCrown";
import Intake from "@/pages/Intake";
import GiftCards from "@/pages/GiftCards";
import Services from "@/pages/Services";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SacredCrown />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
